/*
 * @author: xd
 * @Date: 2021-12-20 19:17:44
 * @LastEditors: xd
 * @LastEditTime: 2022-01-24 16:35:33
 * @Description: 功能
 */
export class ToolBox {
  constructor() {}
  
  static curDateTime(): string {
    var d = new Date();
    var year = d.getFullYear() + "";
    var month = d.getMonth() + 1;
    var date = d.getDate();
    var day = d.getDay();
    var Hours = d.getHours(); //获取当前小时数(0-23)
    var Minutes = d.getMinutes(); //获取当前分钟数(0-59)
    var Seconds = d.getSeconds(); //获取当前秒数(0-59)
    var Milliseconds = d.getMilliseconds();
    var curDateTime = year;
    if (month > 9) {
      curDateTime = curDateTime + month;
    } else {
      curDateTime = curDateTime + "0" + month;
    }
    if (date > 9) curDateTime = curDateTime + date;
    else curDateTime = curDateTime + "0" + date;
    if (Hours > 9) curDateTime = curDateTime + Hours;
    else curDateTime = curDateTime + "0" + Hours;
    if (Minutes > 9) curDateTime = curDateTime + Minutes;
    else curDateTime = curDateTime + "0" + Minutes;
    if (Seconds > 9) curDateTime = curDateTime + Seconds;
    else curDateTime = curDateTime + "0" + Seconds;
    curDateTime = curDateTime + "0" + Milliseconds;
    //alert(curDateTime);
    //document.getElementByIdx_x("NumberNo").value=curDateTime;
    return curDateTime;
  }

  static RndNum(n: number): string {
    var rnd = "";
    for (var i = 0; i < n; i++) {
      rnd += Math.floor(Math.random() * 10);
    }

    return rnd;
  }

  static getTimeAndRandom(): string {
    return ToolBox.curDateTime() + ToolBox.RndNum(4);
  }

  static getJSON(url: string, callback: Function) {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'json';
    xhr.open('get', url, true);
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(xhr.response);
      } else {
        throw new Error(xhr.statusText);
      }
    };
    xhr.send();
  }

  static getJSONSync(url: string):any {
    const xhr = new XMLHttpRequest();
    xhr.open("get", url, false);
    xhr.setRequestHeader("content-type", "application/json");
    xhr.send();
    return JSON.parse(xhr.response);
  }
}
